// frontend/src/hooks/useRecommendations.ts - ACTUALIZADO
import { useState, useEffect, useCallback } from 'react';
import { Recipe } from '@/types';
import { recommendationService } from '@/services/recommendationService';
import { useAuth } from '@/contexts/AuthContext';

export const useRecommendations = () => {
    const [recommendations, setRecommendations] = useState<Recipe[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { token, isLoggedIn, user } = useAuth();

    const loadPersonalizedRecommendations = useCallback(async (limit: number = 10) => {
        if (!isLoggedIn || !token) {
            console.log('🔄 User not logged in, skipping recommendations');
            setRecommendations([]);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            console.log('🔄 Loading personalized recommendations...');
            console.log('👤 Current auth user:', user);
            console.log('🔑 Token exists:', !!token);

            const recipes = await recommendationService.getPersonalizedRecommendations(token, limit);

            console.log('✅ Recommendations loaded successfully:', recipes);
            console.log('📊 Number of recipes:', recipes?.length || 0);

            setRecommendations(recipes || []);

        } catch (err: any) {
            const errorMessage = err.message || 'Error loading recommendations';
            setError(errorMessage);
            console.error('❌ Error loading recommendations:', err);
            setRecommendations([]);
        } finally {
            setLoading(false);
        }
    }, [isLoggedIn, token, user]);

    // ✅ MEJORADO: Escuchar evento de actualización de preferencias
    useEffect(() => {
        const handlePreferencesUpdated = (event: CustomEvent) => {
            console.log('🔄 Preferences updated event received!', event);
            console.log('🕒 Reloading recommendations...');
            loadPersonalizedRecommendations(12); // Recargar con más recetas
        };

        // Escuchar evento personalizado
        window.addEventListener('preferencesUpdated', handlePreferencesUpdated as EventListener);

        return () => {
            window.removeEventListener('preferencesUpdated', handlePreferencesUpdated as EventListener);
        };
    }, [loadPersonalizedRecommendations]);

    // Cargar recomendaciones al montar
    useEffect(() => {
        loadPersonalizedRecommendations(12);
    }, [loadPersonalizedRecommendations]);

    return {
        recommendations,
        loading,
        error,
        refetch: () => loadPersonalizedRecommendations(12)
    };
};